import { render, staticRenderFns } from "./ViewVehicleComponent.vue?vue&type=template&id=6e0df50d"
import script from "./ViewVehicleComponent.vue?vue&type=script&lang=js"
export * from "./ViewVehicleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports